import { render, staticRenderFns } from "./error.vue?vue&type=template&id=1f9cdc53&scoped=true"
import script from "./error.vue?vue&type=script&lang=js"
export * from "./error.vue?vue&type=script&lang=js"
import style0 from "./error.vue?vue&type=style&index=0&id=1f9cdc53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9cdc53",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WfButton: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/common/WfButton.vue').default,Advertisement: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/Advertisement/Advertisement.vue').default,TheSidebar: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/template/TheSidebar.vue').default})
